import * as React from "react";

interface IProps {
  children: any;
}

export default class RiskSlider extends React.PureComponent<IProps, {}> {
  public render() {
    return (
      <ul className="c-risk-slider"> 
        { this.props.children.map(( child:any, index:any ) => (
            <li className="c-risk-slider__slide"
              key={ index }
            >
              { child }
            </li>
         )) }
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilSustainability/RiskSlider.tsx